/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Chat_Context_Used_ShortInputs */



/**
* | output |
* | --- |
* | "{percent}% context" |
*
* @param {Chat_Context_Used_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_context_used_short = /** @type {((inputs: Chat_Context_Used_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Context_Used_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.percent} % Kontext`)
	return /** @type {LocalizedString} */ (`${i?.percent}% context`)
});